




document.getElementById('fwTaxToggle').addEventListener('change', function() {
    
    if(this.checked) {

      pricesWithTax(1);
      localStorage.setItem('ls_pricesWithTax', '1');       
      
    } else {

        pricesWithTax(0);
        localStorage.setItem('ls_pricesWithTax', '0');
        
    }

    //alert(this.checked)

  });


function pricesWithTax(taxIncluded) {

    //alert(taxIncluded)

  document.querySelectorAll('.price__gross').forEach(element => element.style.display = taxIncluded ? 'block' : 'none');
  document.querySelectorAll('.fwPriceDescNet').forEach(element => element.style.display = taxIncluded ? 'none' : 'block');
  document.querySelectorAll('.price__current').forEach(element => element.style.display = taxIncluded ? 'none' : 'block');
  document.querySelectorAll('.fwPriceDescGross').forEach(element => element.style.display = taxIncluded ? 'block' : 'none');

}

function updateTaxToggle(value) {
    document.getElementById('fwTaxToggle').checked = value === 1;
    //alert('updateTaxToggle: ' + value)
}

function fwSetTaxPreference() {

    var VarPricesWithTax = 0; // Standardmäßig auf Netto (0) gesetzt

    let ls_pricesWithTax = localStorage.getItem('ls_pricesWithTax');

    if (ls_pricesWithTax !== null && (ls_pricesWithTax === '0' || ls_pricesWithTax === '1')) {
        
        if (ls_pricesWithTax === '1') {           
            VarPricesWithTax = 1; // Brutto (mit MwSt.) 
        } else {
            VarPricesWithTax = 0; // Netto (ohne MwSt.)
        }
 
        pricesWithTax(VarPricesWithTax);       
        updateTaxToggle(VarPricesWithTax);

        localStorage.setItem('ls_pricesWithTax', VarPricesWithTax.toString());

    } else {

        pricesWithTax(VarPricesWithTax);
        updateTaxToggle(VarPricesWithTax)

        localStorage.setItem('ls_pricesWithTax', VarPricesWithTax.toString());
        //showTaxModal();
        
    }

    //alert("VarPricesWithTax: " + VarPricesWithTax)

}


/* function persistCartAttribute() {
    // Prüfe den LocalStorage-Wert für ls_pricesWithTax
    const ls_pricesWithTax = localStorage.getItem('ls_pricesWithTax');
  
    if (ls_pricesWithTax) {
      fwLog('LocalStorage-Wert gefunden: ls_pricesWithTax = ' + ls_pricesWithTax);
  
      // Attribut im Warenkorb setzen
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: { ls_pricesWithTax: ls_pricesWithTax },
        }),
      })
        .then(response => {
          if (response.ok) {
            fwLog('Cart-Attribut ls_pricesWithTax erfolgreich gesetzt: ' + ls_pricesWithTax);
          } else {
            fwLog('Fehler beim Setzen des Cart-Attributs ls_pricesWithTax');
          }
          return response.json();
        })
        .then(data => {
          fwLog('Cart-Response nach Attribut-Setzen:', data);
        })
        .catch(error => {
          fwLog('Fehler beim Persistieren des Cart-Attributs:', error);
        });
    } else {
      fwLog('Kein ls_pricesWithTax im LocalStorage gefunden. Kein Update erforderlich.');
    }
  }
 */


/* // Funktion zum Anzeigen des Modals
function showTaxModal() {
    var modal = document.getElementById('fwTaxModal');
    modal.style.display = 'flex'; // Modal anzeigen
}

// Funktion zum Schließen des Modals
function closeTaxModal() {
    var modal = document.getElementById('fwTaxModal');
    modal.style.display = 'none'; // Modal ausblenden
} 

// Event Listeners für die Buttons
document.getElementById('fwTaxModalBtnNetto').addEventListener('click', function() {
    pricesWithTax(0);
    localStorage.setItem('ls_pricesWithTax', '0');
    updateTaxToggle(0);
    closeTaxModal(); // Modal schließen nach Auswahl
});

document.getElementById('fwTaxModalBtnBrutto').addEventListener('click', function() {
    pricesWithTax(1);
    localStorage.setItem('ls_pricesWithTax', '1');
    updateTaxToggle(1);
    closeTaxModal(); // Modal schließen nach Auswahl
});

// Event Listener für den Close Button
document.getElementById('fwTaxModalClose').addEventListener('click', function() {
    closeTaxModal();   // Modal schließen, wenn auf den Close Button geklickt wird
});
*/



// Wenn man auf die Zeile klickt, wird die Menge im Eingabefeld auf den Wert der ersten Zelle gesetzt

function updateQuantityFromBulkPrice() {
  // Parse Staffelpreis-String
  function parseBulkPrices(str) {
    const result = {};
    str.split('|').forEach(pair => {
      const [qty, price] = pair.split(':');
      result[parseInt(qty)] = parseFloat(price);
    });
    return result;
  }

  // Preis anhand Menge ermitteln
  function getPriceByQuantity(qty, tierPrices) {
    const tiers = Object.keys(tierPrices)
      .map(Number)
      .sort((a, b) => a - b);

    let matchedTier = tiers[0];
    for (let i = 0; i < tiers.length; i++) {
      if (qty >= tiers[i]) {
        matchedTier = tiers[i];
      } else {
        break;
      }
    }

    return tierPrices[matchedTier];
  }

  // Preise in DOM schreiben
  function updateDisplayedPrices(priceNetto) {
    const priceBrutto = priceNetto * 1.19;

    const targetCurrent = document.querySelector('.price__default .price__current');
    const targetNet = document.querySelector('.price__default .price__gross');

    if (targetCurrent) {
      targetCurrent.textContent = priceNetto.toFixed(2).replace('.', ',') + ' €';
    }

    if (targetNet) {
      targetNet.textContent = priceBrutto.toFixed(2).replace('.', ',') + ' €';
    }
  }

  // Event: Row-Klick
  function bindBulkPriceRows(tierPrices) {
    document.querySelectorAll('.fw_bulk_price_row').forEach(row => {
      row.addEventListener('click', () => {
        document.querySelectorAll('.fw_bulk_price_row').forEach(r => {
          r.classList.remove('fw_bulk_price_row_active');
        });
        row.classList.add('fw_bulk_price_row_active');

        const qty = parseInt(row.querySelector('.fw_bulk_price_cell1')?.textContent.trim());
        if (!isNaN(qty)) {
          const price = getPriceByQuantity(qty, tierPrices);
          updateDisplayedPrices(price);

          const qtyInput = document.querySelector('.qty-input input.qty-input__input');
          if (qtyInput) qtyInput.value = qty;
        }
      });
    });
  }

  // Event: Input-Änderung
  function bindQuantityInput(tierPrices) {
    const input = document.querySelector('.qty-input input.qty-input__input');
    if (!input) return;

    input.addEventListener('input', () => {
      const qty = parseInt(input.value);
      if (!isNaN(qty)) {
        const price = getPriceByQuantity(qty, tierPrices);
        updateDisplayedPrices(price);
      }
    });
  }

  // Init intern auslösen
  const tierPrices = parseBulkPrices(window.fwBulkPriceString || "");
  bindBulkPriceRows(tierPrices);
  bindQuantityInput(tierPrices);
}


function isProductPage() {
    var currentUrl = window.location.href;
    return currentUrl.includes('/products/');
}









// Initialisiert die Wishlist mit Mengenunterstützung
function initializeWishlistWithQuantity() {
    const wishlist = JSON.parse(localStorage.getItem('fwWishlistWithQuantity')) || {};
    updateWishlistCountWithQuantity(wishlist);

    document.querySelectorAll('.fw_coll_wishlist').forEach(divElement => {

        const imgElement = divElement.querySelector('img');
        const productId = divElement.getAttribute('data-product-id');
        const standardSvg = imgElement.getAttribute('data-standard');
        const orangeSvg = imgElement.getAttribute('data-orange');
        const quantityInput = document.querySelector(`.qty-input__input[data-product-id='${productId}']`);

        // Log initiale Werte
        fwLog('Initialisierung des Wishlist-Elements', { productId, initialQuantity: quantityInput ? quantityInput.value : 'keine Eingabe gefunden'});

        // Entferne vorhandene Event-Listener
        if (divElement._wishlistHandler) {
            divElement.removeEventListener('click', divElement._wishlistHandler);
        }

        // Definiere den neuen Event-Listener
        const wishlistHandler = () => {
            const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

            fwLog('Wishlist-Interaktion', {productId, quantity});

            toggleWishlistItemWithQuantity(productId, quantity, imgElement, standardSvg, orangeSvg);
        };

        // Speichere die Listener-Referenz im Element
        divElement._wishlistHandler = wishlistHandler;

        // Initialen Zustand setzen
        if (wishlist[productId]) {
            imgElement.src = orangeSvg;
        } else {
            imgElement.src = standardSvg;
        }

        // Log Status nach Initialisierung
        fwLog('Wishlist-Zustand nach Initialisierung', {productId, isInWishlist: !!wishlist[productId]
        });

        // Neuen Event-Listener hinzufügen
        divElement.addEventListener('click', wishlistHandler);
        
    });
}


function toggleWishlistItemWithQuantity(productId, quantity, imgElement, standardSvg, orangeSvg) {

    //fwLog('toggleWishlistItemWithQuantity', productId, quantity, imgElement, standardSvg, orangeSvg);

    const wishlist = JSON.parse(localStorage.getItem('fwWishlistWithQuantity')) || {};
    const maxItems = 20;

    // Animation hinzufügen
    imgElement.classList.add('animate-scale');

    // Nach der Animation die Klasse entfernen
    setTimeout(() => {
        imgElement.classList.remove('animate-scale');
    }, 300); // Dauer der Animation in Millisekunden

    if (wishlist[productId]) {
        // Produkt entfernen
        delete wishlist[productId];
        imgElement.src = standardSvg;
    } else {
        if (Object.keys(wishlist).length >= maxItems) {
            alert(`Die Anfrageliste kann maximal ${maxItems} Produkte enthalten.`);
            return;
        }

        // Produkt mit Stückzahl hinzufügen
        wishlist[productId] = quantity;
        imgElement.src = orangeSvg;

        //fwLog('Kurz bevor Tracking-Event', productId, quantity);
        // Tracking-Event auslösen
        trackAddToAnfrageliste(productId, quantity);
    

    }

    localStorage.setItem('fwWishlistWithQuantity', JSON.stringify(wishlist));
    updateWishlistCountWithQuantity(wishlist);
}

function updateWishlistCountWithQuantity(wishlist) {
    const countElement = document.getElementById('fwWishlistCount');
    const itemCount = Object.keys(wishlist).length;

    if (itemCount > 0) {
        countElement.style.display = 'flex';
        countElement.textContent = itemCount;
    } else {
        countElement.style.display = 'none';
    }
}


///////////////////////////////////////////////////
////////// Tracking ///////////////////////////////

function trackAddToAnfrageliste(productId, quantity) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "add_anfrageliste",
        product: {
            id: productId,
            quantity: quantity
        }
    });

    fwLog("Event add_anfrageliste gesendet:", productId, quantity);
}




///////////////////////////////////////////////////
////////// shipping modal /////////////////////////

const storefrontAccessToken = "4ad31dcf66643de20f6de5fb145e4c6c";

const loadShippingPolicy = async () => {

  //document.getElementById('fwModalContainer').style.display = 'block';

  try {

    const loader = document.getElementById('fwModalLoader');
    const content = document.getElementById('fwModalContent');

    // Loader anzeigen und Inhalt leeren
    loader.style.display = 'block';
    content.innerHTML = '';

    document.body.style.overflow = 'hidden';
    document.getElementById('fwModalContainer').style.display = 'block';

      const response = await fetch('/api/2023-01/graphql.json', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
          },
          body: JSON.stringify({
              query: `{
                  shop {
                      shippingPolicy {
                          body
                      }
                  }
              }`
          }),
      });

      const data = await response.json();

      fwLog("Shipping geladen:", data);

      const policy = data.data.shop.shippingPolicy;

      if (policy) {
          const content = document.getElementById('fwModalContent');
          content.innerHTML = `<h2>Versandkosten</h2><p>${policy.body}</p>`;
          
      } else {
          console.error('Keine Shipping-Policy gefunden.');
      }
  } catch (error) {
      console.error('Fehler beim Laden der Shipping-Policy:', error);
  } finally {
    document.getElementById('fwModalLoader').style.display = 'none';
  }
};


// Schließen des Modals und Scrollen aktivieren
const closeModal = () => {
  document.getElementById('fwModalContainer').style.display = 'none';
  document.body.style.overflow = 'auto';
};

// Hintergrund-Klick zum Schließen des Modals
document.getElementById('fwModalContainer').addEventListener('click', (event) => {
  if (event.target.id === 'fwModalContainer') {
      closeModal();
  }
});



///////////////////////////////////////////////////
////////// initialise on page load ////////////////

document.addEventListener('DOMContentLoaded', () => {

    if (isProductPage()) {
        updateQuantityFromBulkPrice();
    }

    fwSetTaxPreference();
    initializeWishlistWithQuantity();
    //persistCartAttribute();

});



///////////////////////////////////////////////////
/////// Kachelansicht mobile erzwingen ////////////

document.addEventListener("DOMContentLoaded", function () {
    const isMobile = window.innerWidth <= 768;
    const isRelevantPage = window.location.href.includes("collection") || window.location.href.includes("search");
  
    if (isMobile && isRelevantPage) {
      const listOption = document.getElementById("list-layout-opt");
      const gridOption = document.getElementById("grid-layout-opt");
  
      if (listOption && gridOption) {
        listOption.removeAttribute("checked");
        gridOption.setAttribute("checked", "checked");
  
        // Listenansicht-Label ausblenden
        const listLabel = document.querySelector('label[for="list-layout-opt"]');
        if (listLabel) {
          listLabel.style.display = "none";
        }
  
        // Sichere Umschaltung für iOS/Safari
        setTimeout(() => {
          gridOption.dispatchEvent(new Event("change", { bubbles: true }));
          gridOption.click();
        }, 50);
      }
    }
  });
  


////////////////////////////////////////////////////////////
/////// Frachtkosten/Gesamtkosten laden Warenkorb //////////

const fwCartEvents = {
    init() {
      this.initCartPage();
      this.initCartDrawer();
    },
  
    initCartPage() {
      if (window.location.pathname === '/cart') {
        document.querySelector('cart-items')?.addEventListener('on:line-item:change', () => {
          fwLog('Warenkorb geändert auf /cart – Frachtkosten neu berechnen');
          fwFetchShippingRates("Germany", "21244", "");
        });
  
        // Initial laden
        fwFetchShippingRates("Germany", "21244", "");
      }
    },
  
    initCartDrawer() {
      const cartDrawer = document.querySelector('#cart-drawer');
  
      if (!cartDrawer) return;
  
      // Öffnen beobachten
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'aria-hidden') {
            const isOpen = cartDrawer.getAttribute('aria-hidden') === 'false';
            if (isOpen) {
              fwLog('Cart-Drawer geöffnet – initiale Versandkostenberechnung');
              fwFetchShippingRates("Germany", "21244", "");
            }
          }
        });
      });
  
      observer.observe(cartDrawer, { attributes: true });
  
      // Mengenänderungen überwachen
      cartDrawer.addEventListener('on:line-item:change', () => {
        fwLog('Cart-Drawer Line-Item geändert – Versandkosten neu berechnen');
        fwFetchShippingRates("Germany", "21244", "");
      });

      // Artikel hinzugefügt überwachen
/*       document.addEventListener('on:cart:add', () => {
        fwLog('Artikel hinzugefügt im Cart-Drawer – Versandkosten neu berechnen (mit Timeout)');
        setTimeout(() => {
          fwFetchShippingRates("Germany", "21244", "");
        }, 500); // Timeout in ms – ggf. bei Bedarf erhöhen
      }); */

    }
  };
  
  // Initialisierung beim Laden der Seite
  document.addEventListener('DOMContentLoaded', () => {
    fwCartEvents.init();


  });
  

async function fwFetchShippingRates(country, zip, province) {
  const fwCartTotals = document.getElementById("fwCartTotals");
  const fwCartTotalsLoading = document.getElementById("fwCartTotalsLoading");

  fwLog("CartTOTALS", fwCartTotals, fwCartTotalsLoading);
  
  // Ladeanimation über CSS aktivieren
  fwCartTotals.style.display = "none";
  fwCartTotalsLoading.style.display = "flex";
  fwCartTotalsLoading.style.opacity = "0";
  fwCartTotalsLoading.style.transition = "opacity 0.5s ease-in-out";
  fwCartTotalsLoading.innerHTML = `<div class="fwLoadingSpinner"></div>`;
  
  // Sanft einblenden
  setTimeout(() => {
      fwCartTotalsLoading.style.opacity = "1";
  }, 50);
  
  fwLog("Ladeanimation gestartet");
  
  try {
      const params = new URLSearchParams({
          "shipping_address[zip]": zip,
          "shipping_address[country]": country,
          "shipping_address[province]": province
      }).toString();

      fwLog("Versandparameter:", params);
      
      const response = await fetch(`${theme.routes.cart}/shipping_rates.json?${params}`);
      const data = await response.json();
      
      fwLog("Antwort erhalten:", data);

      if (response.ok && data.shipping_rates) {
          const standardRate = data.shipping_rates.find(rate => rate.name === "Standard");

          if (standardRate) {
              fwLog("Standard-Versand gefunden:", standardRate);
              
              const netShipping = parseFloat(standardRate.price);
              const grossShipping = parseFloat((netShipping * 1.19).toFixed(2));
              
              // Netto-Summe aus dem Div extrahieren
              let netProductsTotalText = document.getElementById("fwCartNetProductsTotal")?.textContent || "0,00 EUR";
              fwLog("fwCartNetProductsTotal Inhalt:", netProductsTotalText);
              
              let netProductsTotal = parseFloat(netProductsTotalText.replace(" EUR", "").replace(/\./g, "").replace(",", ".")) || 0;
              fwLog("Netto-Warenwert berechnet:", netProductsTotal);
              
              // Steuerberechnung exakt wie Shopify
              const taxTotal = parseFloat(((netProductsTotal + netShipping) * 0.19).toFixed(2));
              fwLog("Gesamt-MwSt. (Shopify exakt):", taxTotal);
              
              const grossTotal = parseFloat((netProductsTotal + netShipping + taxTotal).toFixed(2));
              fwLog("Gesamtbetrag berechnet (Shopify exakt):", grossTotal);
              
              const formatPrice = (price) => price.toFixed(2).replace(".", ",");
              
              function updateElement(id, value) {
                  const element = document.getElementById(id);
                  if (element) {
                      element.textContent = `${formatPrice(value)} EUR`;
                      fwLog(`Element ${id} erfolgreich aktualisiert: ${formatPrice(value)} EUR`);
                  } else {
                      fwLog(`Warnung: Element mit ID ${id} nicht gefunden.`);
                  }
              }
              
              updateElement("fwCartShippingNet", netShipping);
              updateElement("fwCartShippingGross", grossShipping);
              updateElement("fwCartTax", taxTotal);
              updateElement("fwCartTotal", grossTotal);
              
              // Erfolgreich geladen: Sanft ausblenden und Totals anzeigen
              fwCartTotalsLoading.style.opacity = "0";
              setTimeout(() => {
                  fwCartTotalsLoading.style.display = "none";
                  fwCartTotals.style.display = "block";
                  fwCartTotals.style.opacity = "0";
                  fwCartTotals.style.transition = "opacity 0.5s ease-in-out";
                  setTimeout(() => {
                      fwCartTotals.style.opacity = "1";
                  }, 50);
              }, 500);
              
              fwLog("Alle Beträge erfolgreich berechnet und eingefügt.");
          } else {
              throw new Error("Kein Standard-Versand gefunden.");
          }
      } else {
          throw new Error("Fehler beim Abrufen der Frachtraten.");
      }
  } catch (error) {
      fwCartTotalsLoading.innerHTML = "<p>Bei der Berechnung der Frachtkosten ist etwas schiefgelaufen, bitte gehen Sie zum Checkout um den Frachtpreis zu ermitteln.</p>";
      fwLog("Fehler beim Abrufen der Frachtraten:", error);
  }
}